<template>
	<span><b role="presentation"></b></span>
</template>